import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, resolveDirective as _resolveDirective, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vModelRadio as _vModelRadio } from "vue"

const _hoisted_1 = { class: "row mb-2" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "row mt-2" }
const _hoisted_5 = {
  for: "trader",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_6 = { class: "col-sm-8" }
const _hoisted_7 = { class: "row mt-2" }
const _hoisted_8 = {
  for: "mappingRowNum",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_9 = { class: "col-sm-8" }
const _hoisted_10 = {
  key: 0,
  class: "row mt-2"
}
const _hoisted_11 = { class: "col-sm-12" }
const _hoisted_12 = { class: "p-0 m-0" }
const _hoisted_13 = {
  key: 1,
  class: "row mt-2"
}
const _hoisted_14 = { class: "col-sm-12" }
const _hoisted_15 = { class: "me-2" }
const _hoisted_16 = { class: "row mt-2" }
const _hoisted_17 = {
  for: "isActive",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_18 = { class: "col-sm-8 form-check form-switch d-flex align-items-center" }
const _hoisted_19 = {
  key: 1,
  class: "row mt-2"
}
const _hoisted_20 = {
  for: "isWhiteTriangle",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_21 = { class: "col-sm-8 form-check form-switch d-flex align-items-center" }
const _hoisted_22 = { class: "row mt-2" }
const _hoisted_23 = {
  for: "currency",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_24 = { class: "col-sm-8" }
const _hoisted_25 = { class: "row mt-2" }
const _hoisted_26 = {
  for: "paymentOption",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_27 = { class: "col-sm-8" }
const _hoisted_28 = { class: "d-flex flex-row align-items-center gap-2" }
const _hoisted_29 = { class: "d-flex flex-row align-items-center gap-1" }
const _hoisted_30 = {
  key: 2,
  class: "row mt-2"
}
const _hoisted_31 = {
  for: "crossBorderCurrency",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_32 = { class: "col-sm-8" }
const _hoisted_33 = { class: "row mt-2" }
const _hoisted_34 = { class: "col-sm-8" }
const _hoisted_35 = { class: "d-flex flex-row align-items-center gap-2" }
const _hoisted_36 = { class: "d-flex flex-row align-items-center gap-1" }
const _hoisted_37 = {
  key: 3,
  class: "row mt-2"
}
const _hoisted_38 = {
  for: "paymentSystem",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_39 = { class: "col-sm-8" }
const _hoisted_40 = { class: "d-flex flex-row align-items-center gap-2" }
const _hoisted_41 = { class: "d-flex flex-row align-items-center gap-1" }
const _hoisted_42 = {
  key: 4,
  class: "row mt-2"
}
const _hoisted_43 = {
  for: "requisites",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_44 = { class: "col-sm-8" }
const _hoisted_45 = ["placeholder", "data-maska", "data-maska-tokens"]
const _hoisted_46 = {
  key: 5,
  class: "row mt-1"
}
const _hoisted_47 = { class: "col-sm-8" }
const _hoisted_48 = { class: "text-muted" }
const _hoisted_49 = {
  key: 6,
  class: "row mt-2"
}
const _hoisted_50 = {
  for: "holderName",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_51 = { class: "col-sm-8" }
const _hoisted_52 = {
  key: 7,
  class: "row mt-2"
}
const _hoisted_53 = {
  for: "crossBorderSwift",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_54 = { class: "text-muted fw-normal" }
const _hoisted_55 = { class: "col-sm-8" }
const _hoisted_56 = {
  key: 8,
  class: "row mt-2"
}
const _hoisted_57 = {
  for: "accountNumber",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_58 = { class: "col-sm-8" }
const _hoisted_59 = {
  key: 9,
  class: "row mt-1 mb-1"
}
const _hoisted_60 = { class: "col-sm-8" }
const _hoisted_61 = { class: "text-muted" }
const _hoisted_62 = { class: "row mt-2" }
const _hoisted_63 = ["for"]
const _hoisted_64 = { class: "col-sm-8" }
const _hoisted_65 = ["onUpdate:modelValue", "id"]
const _hoisted_66 = ["onUpdate:modelValue", "id"]
const _hoisted_67 = {
  key: 10,
  class: "row mt-2"
}
const _hoisted_68 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_69 = { class: "col-sm-8 d-flex align-items-center gap-3" }
const _hoisted_70 = { class: "form-check" }
const _hoisted_71 = {
  class: "form-check-label",
  for: "qrisDynamicAdmin"
}
const _hoisted_72 = { class: "form-check" }
const _hoisted_73 = {
  class: "form-check-label",
  for: "qrisStaticAdmin"
}
const _hoisted_74 = {
  key: 11,
  class: "row mt-2"
}
const _hoisted_75 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_76 = { class: "col-sm-8 d-flex align-items-center gap-3" }
const _hoisted_77 = { class: "form-check" }
const _hoisted_78 = ["checked"]
const _hoisted_79 = {
  class: "form-check-label",
  for: "pixDynamicAdmin"
}
const _hoisted_80 = { class: "form-check" }
const _hoisted_81 = ["checked"]
const _hoisted_82 = {
  class: "form-check-label",
  for: "pixStaticAdmin"
}
const _hoisted_83 = ["for"]
const _hoisted_84 = { class: "col-sm-8" }
const _hoisted_85 = ["readonly", "onUpdate:modelValue", "id"]
const _hoisted_86 = ["readonly", "onUpdate:modelValue", "id"]
const _hoisted_87 = { class: "row mt-2" }
const _hoisted_88 = {
  for: "group",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_89 = { class: "col-sm-8" }
const _hoisted_90 = { class: "row mt-4" }
const _hoisted_91 = {
  for: "device",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_92 = { class: "col-sm-8" }
const _hoisted_93 = { class: "row mt-2" }
const _hoisted_94 = { class: "col-sm-12 col-form-label text-center text-capitalize-first" }
const _hoisted_95 = { class: "row align-items-start" }
const _hoisted_96 = {
  for: "minPayInDealSum",
  class: "col-sm-3 col-form-label text-capitalize-first pe-2 text-end"
}
const _hoisted_97 = { class: "col-sm-3" }
const _hoisted_98 = ["readonly", "disabled"]
const _hoisted_99 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_100 = {
  for: "multiplesOfValue",
  class: "form-label text-capitalize-first mb-1"
}
const _hoisted_101 = {
  for: "maxPayInDealSum",
  class: "col-sm-3 col-form-label text-capitalize-first pe-2 text-end"
}
const _hoisted_102 = { class: "col-sm-3" }
const _hoisted_103 = ["readonly"]
const _hoisted_104 = { class: "row mt-2" }
const _hoisted_105 = {
  for: "dayTradesSumLimit",
  class: "col-sm-3 col-form-label text-capitalize-first pe-2 text-end"
}
const _hoisted_106 = { class: "col-sm-3" }
const _hoisted_107 = {
  for: "monthTradesSumLimit",
  class: "col-sm-3 col-form-label text-capitalize-first pe-2 text-end"
}
const _hoisted_108 = { class: "col-sm-3" }
const _hoisted_109 = { class: "row mt-2" }
const _hoisted_110 = {
  for: "dayTradesCountLimit",
  class: "col-sm-3 col-form-label pe-2 text-capitalize-first text-end"
}
const _hoisted_111 = { class: "col-sm-3" }
const _hoisted_112 = {
  for: "monthTradesCountLimit",
  class: "col-sm-3 col-form-label pe-2 text-capitalize-first text-end"
}
const _hoisted_113 = { class: "col-sm-3" }
const _hoisted_114 = {
  key: 12,
  class: "row mt-2"
}
const _hoisted_115 = {
  for: "dayTradesAllCountLimit",
  class: "col-sm-3 col-form-label pe-2 text-capitalize-first text-end"
}
const _hoisted_116 = { class: "col-sm-3" }
const _hoisted_117 = {
  for: "monthTradesAllCountLimit",
  class: "col-sm-3 col-form-label pe-2 text-capitalize-first text-end"
}
const _hoisted_118 = { class: "col-sm-3" }
const _hoisted_119 = {
  key: 13,
  class: "row mt-2"
}
const _hoisted_120 = {
  for: "totalTradesSumLimit",
  class: "col-sm-3 col-form-label text-capitalize-first pe-2 text-end"
}
const _hoisted_121 = { class: "col-sm-3" }
const _hoisted_122 = {
  for: "totalTradesCountLimit",
  class: "col-sm-3 col-form-label pe-2 text-capitalize-first text-end"
}
const _hoisted_123 = { class: "col-sm-3" }
const _hoisted_124 = {
  key: 14,
  class: "row mt-2 requisites__block--switcher"
}
const _hoisted_125 = { class: "col-sm-3 col-form-label text-capitalize-first pe-2 text-end" }
const _hoisted_126 = { class: "col-sm-3 d-flex align-items-center" }
const _hoisted_127 = { class: "switch" }
const _hoisted_128 = {
  key: 15,
  class: "row mt-2"
}
const _hoisted_129 = {
  for: "maxReuseCount",
  class: "col-sm-3 col-form-label pe-2 text-capitalize-first text-end"
}
const _hoisted_130 = { class: "col-sm-3" }
const _hoisted_131 = {
  for: "reuseDaysCount",
  class: "col-sm-3 col-form-label pe-2 text-capitalize-first text-end"
}
const _hoisted_132 = { class: "col-sm-3" }
const _hoisted_133 = {
  key: 16,
  class: "row mt-2"
}
const _hoisted_134 = {
  for: "reusablePaymentsCountLimit",
  class: "col-sm-3 col-form-label pe-2 text-capitalize-first text-end"
}
const _hoisted_135 = { class: "col-sm-3" }
const _hoisted_136 = ["value"]
const _hoisted_137 = { class: "row mt-4" }
const _hoisted_138 = {
  for: "isFarmsSettingsEnabled",
  class: "col-sm-3 col-form-label text-capitalize-first"
}
const _hoisted_139 = { class: "col-sm-3 form-check form-switch d-flex align-items-center" }
const _hoisted_140 = {
  key: 17,
  class: "row mt-2"
}
const _hoisted_141 = {
  for: "concurrentTradesCount",
  class: "col-sm-3 col-form-label text-capitalize-first pe-2 text-end"
}
const _hoisted_142 = { class: "col-sm-3" }
const _hoisted_143 = {
  for: "tradesTimeoutMinutes",
  class: "col-sm-3 col-form-label text-capitalize-first pe-2 text-end"
}
const _hoisted_144 = { class: "col-sm-3" }
const _hoisted_145 = {
  key: 18,
  class: "row mt-4"
}
const _hoisted_146 = { class: "col-sm-12" }
const _hoisted_147 = { class: "form-check small mb-0" }
const _hoisted_148 = {
  class: "form-check-label",
  for: "isAgreeBlacklistPaymentMethod"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TraderMultiselect = _resolveComponent("TraderMultiselect")!
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_PayMethodIcon = _resolveComponent("PayMethodIcon")!
  const _component_DropzoneInput = _resolveComponent("DropzoneInput")!
  const _component_DevicesMultiselect = _resolveComponent("DevicesMultiselect")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("form", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.isImport)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.helper.trans("labels.trader")), 1),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_FormInputWrapper, {
                    field: "trader",
                    form: "requisitesForm"
                  }, {
                    default: _withCtx((parentProps) => [
                      _createVNode(_component_TraderMultiselect, {
                        id: "trader",
                        class: _normalizeClass(parentProps.class),
                        small: false,
                        modelValue: _ctx.form.trader,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.trader) = $event))
                      }, null, 8, ["class", "modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.helper.trans("labels.row_number")), 1),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_FormInputWrapper, {
                    field: "mappingRowNum",
                    form: "requisitesForm"
                  }, {
                    default: _withCtx((parentProps) => [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.mappingRowNum) = $event)),
                        class: _normalizeClass([parentProps.class, "form-control"]),
                        type: "text",
                        id: "mappingRowNum"
                      }, null, 2), [
                        [_vModelText, _ctx.form.mappingRowNum]
                      ])
                    ]),
                    _: 1
                  })
                ])
              ]),
              (!_ctx.fileAttachment)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _mergeProps({ style: {"cursor":"pointer","border":"1px dashed"} }, _ctx.dropzone.getRootProps(), { class: "payout-dropzone rounded border-secondary p-3 pt-4 pb-4 d-flex justify-content-center align-items-center" }), [
                        _createElementVNode("input", _normalizeProps(_guardReactiveProps(_ctx.dropzone.getInputProps())), null, 16),
                        _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.helper.trans('labels.payout_upload_files')), 1)
                      ], 16)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.fileAttachment)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _cache[40] || (_cache[40] = _createElementVNode("i", { class: "fa fa-paperclip" }, null, -1)),
                      _cache[41] || (_cache[41] = _createTextVNode()),
                      _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.fileAttachment?.file.name), 1),
                      _createElementVNode("a", {
                        href: "#",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.state.fileAttachment = null), ["prevent"]))
                      }, _cache[39] || (_cache[39] = [
                        _createElementVNode("i", { class: "fa fa-times" }, null, -1)
                      ]))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.form.isActive ? _ctx.helper.trans('requisites.active') : _ctx.helper.trans('requisites.inactive')), 1),
          _createElementVNode("div", _hoisted_18, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.isActive) = $event)),
              id: "isActive",
              class: "form-check-input",
              style: {"cursor":"pointer"},
              type: "checkbox",
              role: "switch"
            }, null, 512), [
              [_vModelCheckbox, _ctx.form.isActive]
            ])
          ])
        ]),
        (!_ctx.isAdmin && !_ctx.form.id && _ctx.store.getters.getAppData?.fraudexEnabled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.helper.trans('labels.white_triangle')), 1),
              _createElementVNode("div", _hoisted_21, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.isWhiteTriangle) = $event)),
                  id: "isWhiteTriangle",
                  class: "form-check-input",
                  style: {"cursor":"pointer"},
                  type: "checkbox",
                  role: "switch"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.form.isWhiteTriangle]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.helper.trans("labels.currency")), 1),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_FormInputWrapper, {
              field: "currency",
              form: "requisitesForm"
            }, {
              default: _withCtx((parentProps) => [
                _createVNode(_component_Multiselect, {
                  id: "currency",
                  class: _normalizeClass(["", parentProps.class]),
                  modelValue: _ctx.form.currency,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.currency) = $event)),
                  options: _ctx.store.getters['currencyMethods/currencies'],
                  "custom-label": (opt) => `${opt}`,
                  multiple: false,
                  "select-label": "Select",
                  placeholder: ""
                }, null, 8, ["modelValue", "options", "custom-label", "class"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.helper.trans("labels.payment_method")), 1),
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_FormInputWrapper, {
              field: "paymentOption",
              form: "requisitesForm"
            }, {
              default: _withCtx((parentProps) => [
                _createVNode(_component_Multiselect, {
                  id: "paymentOption",
                  disabled: !_ctx.form.currency,
                  class: _normalizeClass(["", parentProps.class]),
                  modelValue: _ctx.form.paymentOption,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.paymentOption) = $event)),
                  options: _ctx.store.getters['currencyMethods/options'](_ctx.form.currency),
                  "custom-label": (opt) => _ctx.helper.trans(`payment_options.${opt}`),
                  multiple: false,
                  "select-label": "Select",
                  placeholder: ""
                }, {
                  option: _withCtx((props) => [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.helper.trans('payment_options.' + props.option)), 1)
                    ])
                  ]),
                  singleLabel: _withCtx((props) => [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.helper.trans('payment_options.' + props.option)), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["disabled", "modelValue", "options", "custom-label", "class"])
              ]),
              _: 1
            })
          ])
        ]),
        ([_ctx.PaymentOption.CROSS_BORDER, _ctx.PaymentOption.MOBILE_TOP_UP, _ctx.PaymentOption.SBP_QR, _ctx.PaymentOption.CARD_ACQUIRING_REDIRECT].includes(_ctx.form.paymentOption))
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.helper.trans("labels.crossBorderCurrency")), 1),
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_component_FormInputWrapper, {
                  field: "crossBorderCurrency",
                  form: "requisitesForm"
                }, {
                  default: _withCtx((parentProps) => [
                    _createVNode(_component_Multiselect, {
                      id: "currency",
                      class: _normalizeClass(["", parentProps.class]),
                      modelValue: _ctx.form.crossBorderCurrency,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.crossBorderCurrency) = $event)),
                      options: _ctx.store.getters['currencyMethods/crossBorderCurrencies'],
                      "custom-label": (opt) => `${opt}`,
                      multiple: false,
                      "select-label": "Select",
                      placeholder: ""
                    }, null, 8, ["modelValue", "options", "custom-label", "class"])
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_33, [
          _cache[42] || (_cache[42] = _createElementVNode("label", {
            for: "method",
            class: "col-sm-4 col-form-label text-capitalize-first"
          }, null, -1)),
          _createElementVNode("div", _hoisted_34, [
            _createVNode(_component_FormInputWrapper, {
              field: "method",
              form: "requisitesForm"
            }, {
              default: _withCtx((parentProps) => [
                _createVNode(_component_Multiselect, {
                  id: "method",
                  disabled: !_ctx.form.paymentOption || !_ctx.paymentOptionCurrency,
                  class: _normalizeClass(["", parentProps.class]),
                  modelValue: _ctx.form.method,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.method) = $event)),
                  options: _ctx.store.getters['currencyMethods/methods'](_ctx.paymentOptionCurrency, ![_ctx.PaymentOption.CROSS_BORDER, _ctx.PaymentOption.MOBILE_TOP_UP].includes(_ctx.form.paymentOption) ? _ctx.form.paymentOption:  (_ctx.paymentOptionCurrency === 'RUB' ? _ctx.form.paymentOption : null)),
                  "custom-label": (opt) => _ctx.helper.trans(`pay_methods.${opt}`),
                  multiple: false,
                  "select-label": "Select",
                  placeholder: ""
                }, {
                  option: _withCtx((props) => [
                    _createElementVNode("div", _hoisted_35, [
                      _createVNode(_component_PayMethodIcon, {
                        "icon-class": "icon",
                        method: props.option
                      }, null, 8, ["method"]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.helper.trans('pay_methods.' + props.option)), 1)
                    ])
                  ]),
                  singleLabel: _withCtx((props) => [
                    _createElementVNode("div", _hoisted_36, [
                      _createVNode(_component_PayMethodIcon, {
                        "icon-class": "icon",
                        method: props.option
                      }, null, 8, ["method"]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.helper.trans('pay_methods.' + props.option)), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["disabled", "modelValue", "options", "custom-label", "class"])
              ]),
              _: 1
            })
          ])
        ]),
        (_ctx.form.currency && _ctx.form.paymentOption && _ctx.form.method && _ctx.store.getters['currencyMethods/paymentSystems'](_ctx.form.currency, _ctx.form.paymentOption).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
              _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.helper.trans("labels.payment_system")), 1),
              _createElementVNode("div", _hoisted_39, [
                _createVNode(_component_FormInputWrapper, {
                  field: "paymentSystem",
                  form: "paymentSystem"
                }, {
                  default: _withCtx((parentProps) => [
                    _createVNode(_component_Multiselect, {
                      id: "paymentSystem",
                      class: _normalizeClass(["", parentProps.class]),
                      modelValue: _ctx.form.paymentSystem,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.paymentSystem) = $event)),
                      options: _ctx.store.getters['currencyMethods/paymentSystems'](_ctx.form.currency, _ctx.form.paymentOption),
                      "custom-label": (opt) => _ctx.helper.trans(`payment_systems.${opt}`),
                      multiple: false,
                      "select-label": "Select",
                      placeholder: ""
                    }, {
                      option: _withCtx((props) => [
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.helper.trans('payment_systems.' + props.option)), 1)
                        ])
                      ]),
                      singleLabel: _withCtx((props) => [
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.helper.trans('payment_systems.' + props.option)), 1)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "options", "custom-label", "class"])
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isImport && _ctx.form.paymentOption !== _ctx.PaymentOption.VIET_QR && _ctx.form.paymentOption !== _ctx.PaymentOption.IND_QR && _ctx.form.paymentOption !== _ctx.PaymentOption.BR_QR && _ctx.form.paymentOption !== _ctx.PaymentOption.MANUAL_SBP_QR)
          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
              _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.requisiteFieldLabel), 1),
              _createElementVNode("div", _hoisted_44, [
                _createVNode(_component_FormInputWrapper, {
                  field: "requisites",
                  form: "requisitesForm"
                }, {
                  default: _withCtx((parentProps) => [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.requisites) = $event)),
                      placeholder: _ctx.requisitesMaskaPlaceholder,
                      class: _normalizeClass([parentProps.class, "form-control"]),
                      "data-maska": _ctx.requisitesMaskaOptions.pattern,
                      "data-maska-tokens": _ctx.requisitesMaskaOptions.tokens,
                      type: "text",
                      id: "requisites"
                    }, null, 10, _hoisted_45), [
                      [_vModelText, _ctx.form.requisites],
                      [_directive_maska]
                    ])
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.form.paymentOption === _ctx.PaymentOption.SBP_QR && _ctx.form.method === _ctx.PaymentMethod.qr_manager)
          ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
              _cache[43] || (_cache[43] = _createElementVNode("div", { class: "col-sm-4" }, null, -1)),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("small", _hoisted_48, _toDisplayString(_ctx.helper.trans('qr_manager.requisites_hint')), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isImport && _ctx.isHolderNameVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
              _createElementVNode("label", _hoisted_50, _toDisplayString(_ctx.helper.trans("labels.holder_name")), 1),
              _createElementVNode("div", _hoisted_51, [
                _createVNode(_component_FormInputWrapper, {
                  field: "holderName",
                  form: "requisitesForm"
                }, {
                  default: _withCtx((parentProps) => [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.holderName) = $event)),
                      class: _normalizeClass([parentProps.class, "form-control"]),
                      type: "text",
                      id: "holderName"
                    }, null, 2), [
                      [_vModelText, _ctx.form.holderName]
                    ])
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isImport && _ctx.form.paymentOption === _ctx.PaymentOption.CROSS_BORDER)
          ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
              _createElementVNode("label", _hoisted_53, [
                _createTextVNode(_toDisplayString(_ctx.helper.trans("labels.raw_field.swift")) + " ", 1),
                _createElementVNode("small", _hoisted_54, "(" + _toDisplayString(_ctx.helper.trans('labels.optional_field')) + ")", 1)
              ]),
              _createElementVNode("div", _hoisted_55, [
                _createVNode(_component_FormInputWrapper, {
                  field: "raw.swift",
                  form: "requisitesForm"
                }, {
                  default: _withCtx((parentProps) => [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.raw.swift) = $event)),
                      class: _normalizeClass([parentProps.class, "form-control"]),
                      type: "text",
                      id: "crossBorderSwift"
                    }, null, 2), [
                      [_vModelText, _ctx.form.raw.swift]
                    ])
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isImport && _ctx.isAccountNumberVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
              _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.helper.trans("labels.account_number")), 1),
              _createElementVNode("div", _hoisted_58, [
                _createVNode(_component_FormInputWrapper, {
                  field: "accountNumber",
                  form: "requisitesForm"
                }, {
                  default: _withCtx((parentProps) => [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.accountNumber) = $event)),
                      class: _normalizeClass([parentProps.class, "form-control"]),
                      type: "text",
                      id: "accountNumber"
                    }, null, 2), [
                      [_vModelText, _ctx.form.accountNumber]
                    ])
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.form.paymentOption === _ctx.PaymentOption.SBP_QR && _ctx.form.method === _ctx.PaymentMethod.qr_manager && _ctx.additionalFields.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
              _cache[44] || (_cache[44] = _createElementVNode("div", { class: "col-sm-4" }, null, -1)),
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("small", _hoisted_61, _toDisplayString(_ctx.helper.trans('qr_manager.p2c_credentials_intro')), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.additionalFields, (field) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_62, [
            _createElementVNode("label", {
              for: `additional_field_${field.name}`,
              class: "col-sm-4 col-form-label text-capitalize-first"
            }, _toDisplayString(_ctx.helper.trans(`labels.additional_field.${field.name}`)), 9, _hoisted_63),
            _createElementVNode("div", _hoisted_64, [
              _createVNode(_component_FormInputWrapper, {
                field: `additional_field_${field.name}`,
                form: "requisitesForm"
              }, {
                default: _withCtx((parentProps) => [
                  (field.type === 'input')
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        "onUpdate:modelValue": ($event: any) => ((_ctx.form.p2cConfig[field.name]) = $event),
                        class: _normalizeClass([parentProps.class, "form-control"]),
                        type: "text",
                        id: `additional_field_${field.name}`
                      }, null, 10, _hoisted_65)), [
                        [_vModelText, _ctx.form.p2cConfig[field.name]]
                      ])
                    : _createCommentVNode("", true),
                  (field.type === 'textarea')
                    ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                        key: 1,
                        rows: "5",
                        "onUpdate:modelValue": ($event: any) => ((_ctx.form.p2cConfig[field.name]) = $event),
                        class: _normalizeClass([parentProps.class, "form-control"]),
                        type: "text",
                        id: `additional_field_${field.name}`
                      }, null, 10, _hoisted_66)), [
                        [_vModelText, _ctx.form.p2cConfig[field.name]]
                      ])
                    : _createCommentVNode("", true),
                  (field.type === 'dropdown')
                    ? (_openBlock(), _createBlock(_component_Multiselect, {
                        key: 2,
                        class: _normalizeClass(parentProps.class),
                        id: `additional_field_${field.name}`,
                        modelValue: _ctx.form.p2cConfig[field.name],
                        "onUpdate:modelValue": ($event: any) => ((_ctx.form.p2cConfig[field.name]) = $event),
                        options: field.values,
                        "custom-label": (opt) => field.customLabel(opt),
                        multiple: false,
                        "select-label": "Select",
                        placeholder: ""
                      }, null, 8, ["class", "id", "modelValue", "onUpdate:modelValue", "options", "custom-label"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["field"])
            ])
          ]))
        }), 256)),
        (!_ctx.isImport && _ctx.form.paymentOption === _ctx.PaymentOption.IND_QR)
          ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
              _createElementVNode("label", _hoisted_68, _toDisplayString(_ctx.helper.trans("labels.qris_type")), 1),
              _createElementVNode("div", _hoisted_69, [
                _createElementVNode("div", _hoisted_70, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.qrisIsStatic) = $event)),
                    value: false,
                    class: "form-check-input",
                    type: "radio",
                    name: "qrisIsStatic",
                    id: "qrisDynamicAdmin"
                  }, null, 512), [
                    [_vModelRadio, _ctx.form.qrisIsStatic]
                  ]),
                  _createElementVNode("label", _hoisted_71, _toDisplayString(_ctx.helper.trans('labels.qris_dynamic')), 1)
                ]),
                _createElementVNode("div", _hoisted_72, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.qrisIsStatic) = $event)),
                    value: true,
                    class: "form-check-input",
                    type: "radio",
                    name: "qrisIsStatic",
                    id: "qrisStaticAdmin"
                  }, null, 512), [
                    [_vModelRadio, _ctx.form.qrisIsStatic]
                  ]),
                  _createElementVNode("label", _hoisted_73, _toDisplayString(_ctx.helper.trans('labels.qris_static')), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isImport && _ctx.form.paymentOption === _ctx.PaymentOption.BR_QR)
          ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
              _createElementVNode("label", _hoisted_75, _toDisplayString(_ctx.helper.trans("labels.pix_type")), 1),
              _createElementVNode("div", _hoisted_76, [
                _createElementVNode("div", _hoisted_77, [
                  _createElementVNode("input", {
                    checked: _ctx.form.pixIsStatic !== true,
                    class: "form-check-input",
                    type: "radio",
                    name: "pixIsStatic",
                    id: "pixDynamicAdmin",
                    onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.form.pixIsStatic = false))
                  }, null, 40, _hoisted_78),
                  _createElementVNode("label", _hoisted_79, _toDisplayString(_ctx.helper.trans('labels.pix_dynamic')), 1)
                ]),
                _createElementVNode("div", _hoisted_80, [
                  _createElementVNode("input", {
                    checked: _ctx.form.pixIsStatic === true,
                    class: "form-check-input",
                    type: "radio",
                    name: "pixIsStatic",
                    id: "pixStaticAdmin",
                    onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.form.pixIsStatic = true))
                  }, null, 40, _hoisted_81),
                  _createElementVNode("label", _hoisted_82, _toDisplayString(_ctx.helper.trans('labels.pix_static')), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rawFields, (field) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "row mt-2",
            key: field.name
          }, [
            _createElementVNode("label", {
              for: `raw_field_${field.name}`,
              class: "col-sm-4 col-form-label text-capitalize-first"
            }, _toDisplayString(_ctx.helper.trans(`labels.raw_field.${field.name}`, {}, field.name)), 9, _hoisted_83),
            _createElementVNode("div", _hoisted_84, [
              _createVNode(_component_FormInputWrapper, {
                field: `raw_field_${field.name}`,
                form: "requisitesForm"
              }, {
                default: _withCtx((parentProps) => [
                  (field.type === 'input')
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        readonly: field.readonly ?? false,
                        "onUpdate:modelValue": ($event: any) => ((_ctx.form.raw[field.name]) = $event),
                        class: _normalizeClass([parentProps.class, "form-control"]),
                        type: "text",
                        id: `raw_field_${field.name}`
                      }, null, 10, _hoisted_85)), [
                        [_vModelText, _ctx.form.raw[field.name]]
                      ])
                    : _createCommentVNode("", true),
                  (field.type === 'textarea')
                    ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                        key: 1,
                        readonly: field.readonly ?? false,
                        rows: "5",
                        "onUpdate:modelValue": ($event: any) => ((_ctx.form.raw[field.name]) = $event),
                        class: _normalizeClass([parentProps.class, "form-control"]),
                        type: "text",
                        id: `raw_field_${field.name}`
                      }, null, 10, _hoisted_86)), [
                        [_vModelText, _ctx.form.raw[field.name]]
                      ])
                    : _createCommentVNode("", true),
                  (field.type === 'dropzone')
                    ? (_openBlock(), _createBlock(_component_DropzoneInput, {
                        key: 2,
                        options: {accept:['.jpg', '.png', '.jpeg'], multiple: false, maxFiles: 1},
                        onChange: field.dropzone?.onChange,
                        label: field.label
                      }, null, 8, ["onChange", "label"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["field"])
            ])
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_87, [
          _createElementVNode("label", _hoisted_88, _toDisplayString(_ctx.helper.trans("labels.req_group")), 1),
          _createElementVNode("div", _hoisted_89, [
            _createVNode(_component_Multiselect, {
              id: "group",
              class: "",
              modelValue: _ctx.form.groupId,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.groupId) = $event)),
              options: _ctx.store.getters['reqGroups/ids'],
              "custom-label": (opt) => _ctx.store.getters['reqGroups/get'](opt)?.name,
              multiple: false,
              "select-label": "Select",
              placeholder: ""
            }, null, 8, ["modelValue", "options", "custom-label"])
          ])
        ]),
        _createElementVNode("div", _hoisted_90, [
          _createElementVNode("label", _hoisted_91, _toDisplayString(_ctx.helper.trans("labels.device")), 1),
          _createElementVNode("div", _hoisted_92, [
            _createVNode(_component_FormInputWrapper, {
              field: "deviceId",
              form: "requisitesForm"
            }, {
              default: _withCtx((parentProps) => [
                _createVNode(_component_DevicesMultiselect, {
                  id: "device",
                  small: false,
                  class: _normalizeClass(parentProps.class),
                  ref: "deviceMultiselect",
                  multiple: false,
                  "trader-ids": _ctx.form.trader ? [_ctx.form.trader?.id] : [],
                  modelValue: _ctx.form.deviceId,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.deviceId) = $event))
                }, null, 8, ["class", "trader-ids", "modelValue"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_93, [
          _createElementVNode("label", _hoisted_94, _toDisplayString(_ctx.helper.trans("labels.limits")), 1)
        ]),
        _createElementVNode("div", _hoisted_95, [
          _createElementVNode("label", _hoisted_96, _toDisplayString(_ctx.helper.trans("labels.min_pay_in_deal_sum")), 1),
          _createElementVNode("div", _hoisted_97, [
            _createVNode(_component_FormInputWrapper, {
              field: "minPayInDealSum",
              form: "requisitesForm"
            }, {
              default: _withCtx((parentProps) => [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.minPayInDealSum) = $event)),
                  readonly: !_ctx.form.payInDealSumsEditable,
                  disabled: _ctx.isMinSumFieldDisabledByTraderLimit,
                  class: _normalizeClass([[parentProps.class, {'bg-light': _ctx.isMinSumFieldDisabledByTraderLimit}], "form-control"]),
                  "data-maska": "9 99#",
                  "data-maska-tokens": "9:[0-9]:repeated",
                  "data-maska-reversed": "",
                  type: "text",
                  id: "minPayInDealSum"
                }, null, 10, _hoisted_98), [
                  [_vModelText, _ctx.form.minPayInDealSum],
                  [_directive_maska]
                ])
              ]),
              _: 1
            }),
            (_ctx.store.getters.getAppData?.payInMultiplesEnabled)
              ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                  _createElementVNode("label", _hoisted_100, _toDisplayString(_ctx.helper.trans("labels.multiples_of_value")), 1),
                  _createVNode(_component_FormInputWrapper, {
                    field: "multiplesOfValue",
                    form: "requisitesForm"
                  }, {
                    default: _withCtx((parentProps) => [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.form.multiplesOfValue) = $event)),
                        class: _normalizeClass([parentProps.class, "form-control"]),
                        "data-maska": "9 99#",
                        "data-maska-tokens": "9:[0-9]:repeated",
                        "data-maska-reversed": "",
                        type: "text",
                        id: "multiplesOfValue"
                      }, null, 2), [
                        [_vModelText, _ctx.form.multiplesOfValue],
                        [_directive_maska]
                      ])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("label", _hoisted_101, _toDisplayString(_ctx.helper.trans("labels.max_pay_in_deal_sum")), 1),
          _createElementVNode("div", _hoisted_102, [
            _createVNode(_component_FormInputWrapper, {
              field: "maxPayInDealSum",
              form: "requisitesForm"
            }, {
              default: _withCtx((parentProps) => [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.form.maxPayInDealSum) = $event)),
                  readonly: !_ctx.form.payInDealSumsEditable,
                  class: _normalizeClass([parentProps.class, "form-control"]),
                  "data-maska": "9 99#",
                  "data-maska-tokens": "9:[0-9]:repeated",
                  "data-maska-reversed": "",
                  type: "text",
                  id: "maxPayInDealSum"
                }, null, 10, _hoisted_103), [
                  [_vModelText, _ctx.form.maxPayInDealSum],
                  [_directive_maska]
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_104, [
          _createElementVNode("label", _hoisted_105, _toDisplayString(_ctx.helper.trans("labels.daily_sum")), 1),
          _createElementVNode("div", _hoisted_106, [
            _createVNode(_component_FormInputWrapper, {
              field: "dayTradesSumLimit",
              form: "requisitesForm"
            }, {
              default: _withCtx((parentProps) => [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.form.dayTradesSumLimit) = $event)),
                  class: _normalizeClass([parentProps.class, "form-control"]),
                  "data-maska": "9 99#",
                  "data-maska-tokens": "9:[0-9]:repeated",
                  "data-maska-reversed": "",
                  type: "text",
                  id: "dayTradesSumLimit"
                }, null, 2), [
                  [_vModelText, _ctx.form.dayTradesSumLimit],
                  [_directive_maska]
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("label", _hoisted_107, _toDisplayString(_ctx.helper.trans("labels.monthly_sum")), 1),
          _createElementVNode("div", _hoisted_108, [
            _createVNode(_component_FormInputWrapper, {
              field: "monthTradesSumLimit",
              form: "requisitesForm"
            }, {
              default: _withCtx((parentProps) => [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.form.monthTradesSumLimit) = $event)),
                  class: _normalizeClass([parentProps.class, "form-control"]),
                  "data-maska": "9 99#",
                  "data-maska-tokens": "9:[0-9]:repeated",
                  "data-maska-reversed": "",
                  type: "text",
                  id: "monthTradesSumLimit"
                }, null, 2), [
                  [_vModelText, _ctx.form.monthTradesSumLimit],
                  [_directive_maska]
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_109, [
          _createElementVNode("label", _hoisted_110, _toDisplayString(_ctx.helper.trans("labels.daily_qty")), 1),
          _createElementVNode("div", _hoisted_111, [
            _createVNode(_component_FormInputWrapper, {
              field: "dayTradesCountLimit",
              form: "requisitesForm"
            }, {
              default: _withCtx((parentProps) => [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.form.dayTradesCountLimit) = $event)),
                  class: _normalizeClass([parentProps.class, "form-control"]),
                  "data-maska": "9 99#",
                  "data-maska-tokens": "9:[0-9]:repeated",
                  "data-maska-reversed": "",
                  type: "text",
                  required: "",
                  id: "dayTradesCountLimit"
                }, null, 2), [
                  [_vModelText, _ctx.form.dayTradesCountLimit],
                  [_directive_maska]
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("label", _hoisted_112, _toDisplayString(_ctx.helper.trans("labels.monthly_qty")), 1),
          _createElementVNode("div", _hoisted_113, [
            _createVNode(_component_FormInputWrapper, {
              field: "monthTradesCountLimit",
              form: "requisitesForm"
            }, {
              default: _withCtx((parentProps) => [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.form.monthTradesCountLimit) = $event)),
                  class: _normalizeClass([parentProps.class, "form-control"]),
                  "data-maska": "9 99#",
                  "data-maska-tokens": "9:[0-9]:repeated",
                  "data-maska-reversed": "",
                  type: "text",
                  required: "",
                  id: "monthTradesCountLimit"
                }, null, 2), [
                  [_vModelText, _ctx.form.monthTradesCountLimit],
                  [_directive_maska]
                ])
              ]),
              _: 1
            })
          ])
        ]),
        (_ctx.store.getters.getAppData?.requisitesAllDealsCountLimitsEnabled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
              _createElementVNode("label", _hoisted_115, _toDisplayString(_ctx.helper.trans("labels.daily_qty_all_deals")), 1),
              _createElementVNode("div", _hoisted_116, [
                _createVNode(_component_FormInputWrapper, {
                  field: "dayTradesAllCountLimit",
                  form: "requisitesForm"
                }, {
                  default: _withCtx((parentProps) => [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.form.dayTradesAllCountLimit) = $event)),
                      class: _normalizeClass([parentProps.class, "form-control"]),
                      "data-maska": "9 99#",
                      "data-maska-tokens": "9:[0-9]:repeated",
                      "data-maska-reversed": "",
                      type: "text",
                      required: "",
                      id: "dayTradesAllCountLimit"
                    }, null, 2), [
                      [_vModelText, _ctx.form.dayTradesAllCountLimit],
                      [_directive_maska]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("label", _hoisted_117, _toDisplayString(_ctx.helper.trans("labels.monthly_qty_all_deals")), 1),
              _createElementVNode("div", _hoisted_118, [
                _createVNode(_component_FormInputWrapper, {
                  field: "monthTradesAllCountLimit",
                  form: "requisitesForm"
                }, {
                  default: _withCtx((parentProps) => [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.form.monthTradesAllCountLimit) = $event)),
                      class: _normalizeClass([parentProps.class, "form-control"]),
                      "data-maska": "9 99#",
                      "data-maska-tokens": "9:[0-9]:repeated",
                      "data-maska-reversed": "",
                      type: "text",
                      required: "",
                      id: "monthTradesAllCountLimit"
                    }, null, 2), [
                      [_vModelText, _ctx.form.monthTradesAllCountLimit],
                      [_directive_maska]
                    ])
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.store.getters.getAppData?.requisitesTotalLimitEnabled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
              _createElementVNode("label", _hoisted_120, _toDisplayString(_ctx.helper.trans("labels.total_sum")), 1),
              _createElementVNode("div", _hoisted_121, [
                _createVNode(_component_FormInputWrapper, {
                  field: "totalTradesSumLimit",
                  form: "requisitesForm"
                }, {
                  default: _withCtx((parentProps) => [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.form.totalTradesSumLimit) = $event)),
                      class: _normalizeClass([parentProps.class, "form-control"]),
                      "data-maska": "9 99#",
                      "data-maska-tokens": "9:[0-9]:repeated",
                      "data-maska-reversed": "",
                      type: "text",
                      id: "totalTradesSumLimit"
                    }, null, 2), [
                      [_vModelText, _ctx.form.totalTradesSumLimit],
                      [_directive_maska]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("label", _hoisted_122, _toDisplayString(_ctx.helper.trans("labels.total_qty")), 1),
              _createElementVNode("div", _hoisted_123, [
                _createVNode(_component_FormInputWrapper, {
                  field: "totalTradesCountLimit",
                  form: "requisitesForm"
                }, {
                  default: _withCtx((parentProps) => [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.form.totalTradesCountLimit) = $event)),
                      class: _normalizeClass([parentProps.class, "form-control"]),
                      "data-maska": "9 99#",
                      "data-maska-tokens": "9:[0-9]:repeated",
                      "data-maska-reversed": "",
                      type: "text",
                      required: "",
                      id: "totalTradesCountLimit"
                    }, null, 2), [
                      [_vModelText, _ctx.form.totalTradesCountLimit],
                      [_directive_maska]
                    ])
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.store.getters.getAppData?.requisitesTotalLimitEnabled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
              _createElementVNode("label", _hoisted_125, _toDisplayString(_ctx.helper.trans('labels.manual_reset_enabled')), 1),
              _createElementVNode("div", _hoisted_126, [
                _createElementVNode("label", _hoisted_127, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.form.manualResetEnabled) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.form.manualResetEnabled]
                  ]),
                  _cache[45] || (_cache[45] = _createElementVNode("span", { class: "slider" }, null, -1))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.form.maxReuseCountEnable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
              _createElementVNode("label", _hoisted_129, _toDisplayString(_ctx.helper.trans("labels.maxReuseCount")), 1),
              _createElementVNode("div", _hoisted_130, [
                _createVNode(_component_FormInputWrapper, {
                  field: "maxReuseCount",
                  form: "requisitesForm"
                }, {
                  default: _withCtx((parentProps) => [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.form.maxReuseCount) = $event)),
                      class: _normalizeClass([parentProps.class, "form-control"]),
                      "data-maska": "9 99#",
                      "data-maska-tokens": "9:[0-9]:repeated",
                      "data-maska-reversed": "",
                      type: "text",
                      required: "",
                      id: "maxReuseCount"
                    }, null, 2), [
                      [_vModelText, _ctx.form.maxReuseCount],
                      [_directive_maska]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("label", _hoisted_131, _toDisplayString(_ctx.helper.trans("labels.reuseDaysCount")), 1),
              _createElementVNode("div", _hoisted_132, [
                _createVNode(_component_FormInputWrapper, {
                  field: "reuseDaysCount",
                  form: "requisitesForm"
                }, {
                  default: _withCtx((parentProps) => [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.form.reuseDaysCount) = $event)),
                      class: _normalizeClass([parentProps.class, "form-control"]),
                      "data-maska": "9 99#",
                      "data-maska-tokens": "9:[0-9]:repeated",
                      "data-maska-reversed": "",
                      type: "text",
                      required: "",
                      id: "reuseDaysCount"
                    }, null, 2), [
                      [_vModelText, _ctx.form.reuseDaysCount],
                      [_directive_maska]
                    ])
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.form.maxReuseCountEnable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_133, [
              _createElementVNode("label", _hoisted_134, _toDisplayString(_ctx.helper.trans("labels.reusablePaymentsCountLimit")), 1),
              _createElementVNode("div", _hoisted_135, [
                (!_ctx.store.getters.getAppData?.requisitesReusablePaymentsCountLimitEnabled)
                  ? (_openBlock(), _createBlock(_component_FormInputWrapper, {
                      key: 0,
                      field: "reusablePaymentsCountLimit",
                      form: "requisitesForm"
                    }, {
                      default: _withCtx((parentProps) => [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.form.reusablePaymentsCountLimit) = $event)),
                          class: _normalizeClass([parentProps.class, "form-control"]),
                          "data-maska": "9 99#",
                          "data-maska-tokens": "9:[0-9]:repeated",
                          "data-maska-reversed": "",
                          type: "text",
                          required: "",
                          id: "reusablePaymentsCountLimit"
                        }, null, 2), [
                          [_vModelText, _ctx.form.reusablePaymentsCountLimit],
                          [_directive_maska]
                        ])
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createElementBlock("input", {
                      key: 1,
                      value: _ctx.store.getters.getAppData?.requisitesReusablePaymentsCountLimit ?? 11,
                      disabled: "",
                      type: "text",
                      class: "form-control",
                      id: "reusablePaymentsCountLimit"
                    }, null, 8, _hoisted_136))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_137, [
          _createElementVNode("label", _hoisted_138, _toDisplayString(_ctx.helper.trans('labels.farmsSettings')), 1),
          _createElementVNode("div", _hoisted_139, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.form.isFarmsSettingsEnabled) = $event)),
              id: "isFarmsSettingsEnabled",
              class: "form-check-input",
              style: {"cursor":"pointer"},
              type: "checkbox",
              role: "switch"
            }, null, 512), [
              [_vModelCheckbox, _ctx.form.isFarmsSettingsEnabled]
            ])
          ])
        ]),
        (_ctx.form.isFarmsSettingsEnabled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_140, [
              _createElementVNode("label", _hoisted_141, _toDisplayString(_ctx.helper.trans("labels.concurrent_trader_count")), 1),
              _createElementVNode("div", _hoisted_142, [
                _createVNode(_component_FormInputWrapper, {
                  field: "concurrentTradesCount",
                  form: "requisitesForm"
                }, {
                  default: _withCtx((parentProps) => [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.form.concurrentTradesCount) = $event)),
                      class: _normalizeClass([parentProps.class, "form-control"]),
                      "data-maska": "9 99#",
                      "data-maska-tokens": "9:[0-9]:repeated",
                      "data-maska-reversed": "",
                      type: "text",
                      id: "concurrentTradesCount"
                    }, null, 2), [
                      [_vModelText, _ctx.form.concurrentTradesCount],
                      [_directive_maska]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("label", _hoisted_143, _toDisplayString(_ctx.helper.trans("labels.trades_timeout_minutes")), 1),
              _createElementVNode("div", _hoisted_144, [
                _createVNode(_component_FormInputWrapper, {
                  field: "tradesTimeoutMinutes",
                  form: "requisitesForm"
                }, {
                  default: _withCtx((parentProps) => [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.form.tradesTimeoutMinutes) = $event)),
                      class: _normalizeClass([parentProps.class, "form-control"]),
                      "data-maska": "9 99#",
                      "data-maska-tokens": "9:[0-9]:repeated",
                      "data-maska-reversed": "",
                      type: "text",
                      id: "tradesTimeoutMinutes"
                    }, null, 2), [
                      [_vModelText, _ctx.form.tradesTimeoutMinutes],
                      [_directive_maska]
                    ])
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.form.method && _ctx.blacklistMethods.includes(_ctx.form.method))
          ? (_openBlock(), _createElementBlock("div", _hoisted_145, [
              _createElementVNode("div", _hoisted_146, [
                _createVNode(_component_FormInputWrapper, {
                  field: "isAgreeBlacklistPaymentMethod",
                  form: "requisitesForm"
                }, {
                  default: _withCtx((parentProps) => [
                    _createElementVNode("div", {
                      class: _normalizeClass(["alert alert-danger mb-0", parentProps.class]),
                      role: "alert"
                    }, [
                      _createElementVNode("div", _hoisted_147, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.form.isAgreeBlacklistPaymentMethod) = $event)),
                          type: "checkbox",
                          value: "",
                          id: "isAgreeBlacklistPaymentMethod"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.form.isAgreeBlacklistPaymentMethod]
                        ]),
                        _createElementVNode("label", _hoisted_148, _toDisplayString(_ctx.helper.trans('labels.agree_with_risk')), 1)
                      ])
                    ], 2)
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}